module.exports = __webpack_public_path__ + "static/media/face_detection_video.ec752429.mp4";